<template>
  <div>
    <div :class="{'d-flex flex-wrap': flex}">
      <div
        v-for="index in max"
        v-bind:key="index"
        :class="{'mr-2': flex}"
        v-bind:style="{ width: flexWidth, maxWidth: flexWidth }"
      >
        <div class="input-group mb-1" :class="[sizeVal]">
          <div class="input-group-prepend input-group-prepend-list-editor" v-if="showIndex">
            <span class="input-group-text">
              <span v-if="prefix">{{prefix}}</span>
              {{index}}
            </span>
          </div>
          <input type="text" class="form-control" v-model="items[index-1]">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    max: {
      type: Number,
      default: () => Number.MAX_SAFE_INTEGER
    },
    prefix: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    flex: {
      type: Boolean,
      default: false
    },
    flexWidth: {
      type: String,
      default: ""
    }
  },
  computed: {
    sizeVal() {
      return this.size ? `input-group-${this.size}` : "";
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
